import React, { useState, useEffect, useCallback } from 'react'
import { Numeral } from 'components'
import { StyledSlider, Track, Thumb } from './MultiRangeSlider.style'

const MultiRangeSlider = ({
  max,
  min,
  step,
  onChange,
  disabled,
  value,
  format,
}) => {
  const [selectedValue, setSelectedValue] = useState(value || [min, max])
  useEffect(() => {
    setSelectedValue(value || [min, max])
  }, [value])

  const fixValues = useCallback(
    ([minimum, maximum]) => {
      if (step < 10) return [minimum, maximum]

      if (min !== minimum) {
        return [minimum - (minimum % step), maximum - (maximum % step)]
      } else {
        return [minimum, maximum - (maximum % step)]
      }
    },
    [min, step]
  )

  const handleOnAfterChange = (selected) => {
    const fixedValues = fixValues(selected)
    setSelectedValue(fixedValues)
    onChange(fixedValues)
  }

  return (
    <>
      <StyledSlider
        disabled={disabled}
        min={min}
        max={max}
        value={selectedValue}
        renderTrack={Track}
        renderThumb={Thumb}
        step={step}
        onChange={(selected) => setSelectedValue(fixValues(selected))}
        onAfterChange={handleOnAfterChange}
        pearling
      />
      <div className="my-3 small">
        <Numeral value={selectedValue[0]} format={format} />
        <div className="float-right">
          <Numeral value={selectedValue[1]} format={format} />
        </div>
      </div>
    </>
  )
}

export default MultiRangeSlider
